import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';

interface AddEntryButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Dashed "+ Add X" button shown in a valuation form section's blank state.
 * Clicking it reveals the section's input fields (presentation only — the
 * underlying data model and save flow are unchanged).
 *
 * Full width: the parent places it in the same grid cell(s) as the fields it
 * reveals, so the button is exactly as wide as the revealed content.
 */
export function AddEntryButton({ label, onClick, disabled = false }: AddEntryButtonProps) {
  const { darkMode } = useDarkMode();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full rounded-lg border border-dashed px-3 py-2 text-left text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
        darkMode
          ? 'border-white/10 text-indigo-400 hover:border-white/25 hover:bg-white/5'
          : 'border-gray-900/10 text-indigo-600 hover:border-gray-900/25 hover:bg-gray-50'
      }`}
    >
      + Add {label}
    </button>
  );
}
